import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import {t} from 'i18next'
import DataTable from 'react-data-table-component'
import { FormGroup, Button } from 'reactstrap'
import moment from 'moment'

import { customStyles, displayDate } from '../../../izUtils'
import DictionaryInfoButton from '../../dictionary/DictionaryInfoButton'

const PriceList = ({data, tokenData}) => {
    const Navigate = useNavigate();

    const handleRowClick = (state) => {
        Navigate('/prices/' + state.id + '/get')
    }

    const handleNavigate = (row, type) => {
        Navigate('/prices/' + row.id + '/' + type)
    }

    // This loops through rows and creates them
    const tableColumns = useMemo(() => {
        let columns = [{
            name: t('table.active_from'),
            selector: row => displayDate(moment.utc(row.active_from), 'date'),
            sortable: true,
        }]

        if (tokenData.parsedToken.type === 'admin') {
            columns.push({
                name: '',
                sortable: false,
                cell: row => <div className="d-flex align-items-center">
                    <Button color='secondary' onClick={() => handleNavigate(row, 'update')} className="me-2">{t('edit')}</Button>
                    <DictionaryInfoButton code={"prices.list.edit_with_contract"} id={"prices.list.edit_with_contract-" + row.id} />
                </div>
            })
        }

        return columns;
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <FormGroup>
            <DataTable
                columns={tableColumns}
                data={data}
                customStyles={customStyles}
                onRowClicked={handleRowClick}
            />
        </FormGroup>
    )
}

export default PriceList